import { TextField, type TextFieldProps } from "@mui/material";
import { useState, type FC } from "react";

type TimeSelectorProps = Omit<TextFieldProps, "onChange" | "value"> & {
  onChange: (value?: string) => void;
  value?: string;
};

export const TimeSelector: FC<TimeSelectorProps> = ({
  onChange,
  value,
  sx,
  ...props
}: TimeSelectorProps) => {
  const [fieldValue, setFieldValue] = useState<string | undefined>(value);

  return (
    <TextField
      variant="standard"
      type="time"
      sx={{ width: 130, paddingLeft: 1, ...sx }}
      value={fieldValue}
      onBlur={() => onChange(fieldValue)}
      onChange={(x) => setFieldValue(x.target.value ?? undefined)}
      {...props}
    />
  );
};
